var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Counter',{attrs:{"title":_vm.$t('Sponsoring'),"data":_vm.formattedCount}})
}
var staticRenderFns = []

export { render, staticRenderFns }